import { supabase } from '../lib/supabase';

// Table schema suggestion: learning_progress
// columns: id (uuid), user_id (uuid), item_id (text), completed (bool),
// completed_at (timestamptz), analysis_id (uuid), skill (text), type (text), url (text)

const TABLE = 'learning_progress';

export async function getProgressMap(userId) {
  const { data, error } = await supabase
    .from(TABLE)
    .select('item_id, completed')
    .eq('user_id', userId);
  if (error) throw error;
  const map = {};
  (data || []).forEach(r => { map[r.item_id] = !!r.completed; });
  return map;
}

export async function upsertProgress(userId, item) {
  const payload = {
    user_id: userId,
    item_id: item.id,
    completed: !!item.completed,
    completed_at: item.completed ? new Date().toISOString() : null,
    analysis_id: item.analysis_id || null,
    skill: item.skill || null,
    type: item.type || null,
    url: item.url || null
  };
  const { error } = await supabase
    .from(TABLE)
    .upsert(payload, { onConflict: 'user_id,item_id' });
  if (error) throw error;
}

export async function getProgressHistory(userId, limit = 30) {
  const { data, error } = await supabase
    .from(TABLE)
    .select('completed_at')
    .eq('user_id', userId)
    .eq('completed', true)
    .order('completed_at', { ascending: true })
    .limit(limit);
  if (error) throw error;
  return data || [];
}